// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2HF6B","col":"styles_col__CL5R8"};